import { render, staticRenderFns } from "./TagUserRankDiscount.vue?vue&type=template&id=2da69e04&scoped=true&"
import script from "./TagUserRankDiscount.vue?vue&type=script&lang=js&"
export * from "./TagUserRankDiscount.vue?vue&type=script&lang=js&"
import style0 from "./TagUserRankDiscount.vue?vue&type=style&index=0&id=2da69e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da69e04",
  null
  
)

export default component.exports